import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';

import {
  AssignmentSagaAction,
  AssignClaimAction,
} from 'containers/CourtManagerAssignedClaims/typings';
import userToken from 'containers/services/security/access-token-storage';
import { setAssignedClaimsBySubServices } from 'containers/CourtManagerAssignedClaims/actions';
import {
  REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
  REQUEST_ASSIGN_CLAIM_TO_MANAGER,
} from 'containers/CourtManagerAssignedClaims/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { get } from 'lodash';

export function* fetchAssignedClaims(
  action: AssignmentSagaAction,
): Generator<unknown> {
  const {
    page,
    pageSize,
    step,
    procedureType,
    assignedManagerCode,
    isManager,
    isInboxesActive,
  } = action;
  const token = get(userToken.get(), 'token');
  const assignedSubServices = get(
    currentUserStorage.get(),
    ['subservices', 'subeservicesId'],
    [],
  ).map((ele: number) => ele.toString());
  if (!assignedManagerCode && !isManager) return null;
  const path = `/corporeal/assignment/assigned-claims/v2`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      assignedSubServices,
      assignedManagerCode,
      page,
      pageSize,
      step,
      procedureType,
      isManager,
      isInboxesActive,
    }),
  };

  yield callApi(path, {}, options, [], setAssignedClaimsBySubServices);
}

export function* fetchAssignedClaimsSaga() {
  yield takeLeading(
    REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
    fetchAssignedClaims,
  );
}

export function* requestAssignClaimToManager(
  action: AssignClaimAction,
): Generator<unknown> {
  const { payload, successCallback } = action;

  const path = `/corporeal/assignment/assign-court-manager`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${payload.token}`,
    },
    body: JSON.stringify({ id: payload.assignmentId }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    successCallback();
  }
}

export function* requestAssignClaimToManagerSaga() {
  yield takeLeading(
    REQUEST_ASSIGN_CLAIM_TO_MANAGER,
    requestAssignClaimToManager,
  );
}

export default [fetchAssignedClaimsSaga, requestAssignClaimToManagerSaga];
